import Theme from 'Theme/index';

export default {
    PIXELS_PER_MIN: 6.86,
    currentTimeUpdateInterval: 60,
    grid: {
        backgroundColor: 'transparent'
    },
    cell: {
        container: {
            height: 71,
            paddingHorizontal: 18,
            borderColor: '#393f41',
            borderWidth: 1,
            backgroundColor: 'transparent'
        },
        titleContainerWithIcon: {
            display: 'inline-flex'
        },
        activeContainer: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderColor: '#393f41',
            borderWidth: 1
        },
        selectedContainer: {
            backgroundColor: '#e40f74'
        },
        title: {
            color: '#ebebeb',
            fontSize: 21,
            letterSpacing: 0.7,
            fontFamily: Theme.thinFont
        },
        lockedTitle: {
            color: '#7d7d7d'
        },
        description: {
            color: '#a4a4a4',
            fontSize: 15,
            letterSpacing: 0.4,
            fontFamily: Theme.regularFont
        },
        focused: {
            backgroundColor: Theme.primaryActiveColor
        },
        icon: {
            marginLeft: 8,
            width: 20,
            height: 20
        }
    },
    sidebar: {
        container: {
            width: 144,
            borderTop: '1px solid rgba(255,255,255,0.15)',
            backgroundColor: 'rgba(38,38,38,0.8)',
            borderBottom: '1px solid rgba(255,255,255,0.15)',
            boxSizing: 'border-box'
        },
        logo: {
            height: 70
        },
        text: {
            color: '#F7F7F7',
            fontFamily: Theme.regularFont,
            fontSize: 20,
            fontWeight: '300'
        }
    },
    timeline: {
        container: {
            height: 48,
            backgroundColor: 'transparent'
        },
        text: {
            color: '#a4a4a4',
            fontFamily: Theme.thinFont,
            fontSize: 18,
            letterSpacing: 0.7
        }
    },
    currentTime: {
        line: {
            backgroundColor: Theme.primaryActiveColor,
            width: 1
        },
        label: {
            backgroundColor: Theme.primaryActiveColor,
            borderRadius: 3,
            width: 58,
            height: '40%',
            top: '30%'
        },
        labelText: {
            color: '#EBEBEB',
            fontFamily: Theme.regularFont,
            fontSize: 15,
            fontWeight: '300',
            textAlign: 'center',
            letterSpacing: 1
        }
    },
    filters: {
        window: {
            container: {
                backgroundColor: 'rgba(255,255,255, 0.95)'
            },
            line: {
                backgroundColor: 'transparent',
                borderBottomColor: '#c4c4c5',
                borderBottomWidth: 1,
                height: 55,
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'row',
                width: '100%'
            },
            activeLine: {
                backgroundColor: '#a5a5a5'
            },
            lineText: {
                color: '#6c6c6c',
                fontSize: 18,
                marginRight: 10,
                marginLeft: 12,
                fontFamily: Theme.regularFont
            },
            lineTextActive: {
                color: '#00a0de'
            },
            categoryItemCount: {
                fontFamily: Theme.regularFont,
                fontSize: 17,
                color: '#8f8f8f'
            },
            filterRowItem: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            },
            icon: {
                width: 18,
                height: 18,
                marginHorizontal: 9
            }
        }
    }
};
